import { Aba6PosrecadComponent } from './components/pos-recadastramento/aba6-posrecad/aba6-posrecad.component';
import { Aba4PosrecadComponent } from './components/pos-recadastramento/aba4-posrecad/aba4-posrecad.component';
import { RecadastramentoAba5Component } from './components/recadastramento-aba5/recadastramento-aba5.component';
import { RecadastramentoAba4Component } from './components/recadastramento-aba4/recadastramento-aba4.component';
import { CommonModule, HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { forwardRef, NgModule } from '@angular/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import 'hammerjs';
import { BlockUIModule } from 'ng-block-ui';
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { ChartsModule } from 'ng2-charts';
import { NgxHmCarouselModule } from 'ngx-hm-carousel';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth/_guards';
import { AuthInterceptor } from './auth/_guards/auth.interceptor';
import { AuthModule } from './auth/_guards/auth.module';
import { IdentityStorage } from './auth/_models/identity.storage';
import { AuthenticationService } from './auth/_services';
import { MaterialModule } from './material.module';
import { BaseComponent } from './pages/base/base.component';
import { MatPaginatorIntlPortuguese } from './pages/table-format-page/mat-paginator-int';
import { FooterComponent } from './pages/template/footer/footer.component';
import { HeaderComponent } from './pages/template/header/header.component';
import { PadraoService } from './service/padrao/padrao.service';
import { UsuarioService } from './service/usuario/usuario.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { LoginComponent } from './pages/login/login.component';
import { BensValoresComponent } from './pages/bens-valores/bens-valores.component';
import { RecadastramentoAtivosComponent } from './pages/recadastramento-ativos/recadastramento-ativos.component';
import { BarraNavegacaoComponent } from './components/barra-navegacao/barra-navegacao.component';
import { CardInfoServidorComponent } from './components/card-info-servidor/card-info-servidor.component';
import { RecadastramentoAba1Component } from './components/recadastramento-aba1/recadastramento-aba1.component';
import { RecadastramentoAba2Component } from './components/recadastramento-aba2/recadastramento-aba2.component';
import { DatePipe } from '@angular/common';
import {HomeService} from "./service/home/home.service";
import {UploadService} from "./service/upload/upload.service";
import { ImpostoRendaService } from './service/Imposto-renda-service/imposto-renda.service';
import {AutorizacaoDeAcessoService} from "./service/autorizacao-de-acesso/autorizacao-de-acesso.service";
import { HandleErrorService } from './auth/_services/handleError.service';
import { DadosPessoaisAba1 } from './service/dados-pessoais-aba1/dados-pessoais-aba1';
import { DadosPessoaisAba1DTO} from "./model/dadoaPessoaisAba1.dto";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EnumService } from './service/enum/enum';
import { ReactiveFormsModule } from '@angular/forms';
import { RecadastramentoAba3Component } from "./components/recadastramento-aba3/recadastramento-aba3.component";
import {DocumentosPessoaisAba3Service} from "./service/documentos-pessoais-aba3/documentos-pessoais-aba3.service";
import { EnderecoAba4Service } from './service/endereco-aba4/endereco.service';
import { TrabalhadorEstrangeiroAba5Service } from './service/dados-trabalhar-estrangeiro-aba5/dados-trabalhar-estrangeiro-aba5.service';
import { DadosPortadorDeficienciaServiceAba6 } from "./service/dados-deficiencia-aba6/dados-deficiencia-aba6.service";

import {LocalidadesIbgeService} from "./service/localidades-ibge/localidades-ibge.service";
import { EnderecoService } from './service/endereco-aba4/endereco-aba3.service';
import { EnderecoViaCep } from './service/enderecoViaCep/enderecoViaCep.service';
import { DadosContatoAba8 } from './service/dados-contato-aba8/dados-contato-aba8.service';
import { DadosParentescoServiceAba9 } from './service/dados-parentesco-aba9/dados-parentesco-aba9.service';
import { DadosAuxilioTransporte } from './service/dados-transporte-aba12/dados-auxilio-transporte.service';

import { RecadastramentoAba6Component } from './components/recadastramento-aba6/recadastramento-aba6.component';
import {OnlyNumberDirective} from "./directives/only-number-directive.directive";
import { TelefonePipe } from './directives/telefone.directive';
import {MatExpansionModule} from '@angular/material/expansion';
import { RecadastramentoAba7Component } from './components/recadastramento-aba7/recadastramento-aba7.component';
import { RecadastramentoAba8Component } from './components/recadastramento-aba8/recadastramento-aba8.component';
import { RecadastramentoAba9Component } from './components/recadastramento-aba9/recadastramento-aba9.component';
import { RecadastramentoAba10Component } from './components/recadastramento-aba10/recadastramento-aba10.component';
import { LOCALE_ID } from '@angular/core';
import { CurrencyMaskModule } from "ng2-currency-mask";

import {MatListModule} from '@angular/material/list';
import { RecadastramentoAba11Component } from './components/recadastramento-aba11/recadastramento-aba11.component';
import { RecadastramentoAba12Component } from './components/recadastramento-aba12/recadastramento-aba12.component';
import { RecadastramentoAba13Component } from './components/recadastramento-aba13/recadastramento-aba13.component';
import { RecadastramentoAba14Component } from './components/recadastramento-aba14/recadastramento-aba14.component';
import { ModalDialogComponent } from './components/modal-dialog/modal-dialog.component';
import { ConselhoAba13Service } from './service/conselho-aba-13/conselho-aba-13.service';
import { SidenavComponent } from './pages/template/sidenav/sidenav.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import { HomeComponent } from './pages/home/home.component';
import {CampanhasComponent} from "./components/campanhas/campanhas.component";
import {ExcecoesComponent, MY_FORMATS} from "./components/excecoes/excecoes.component";
import {ParametrizacoesComponent} from "./pages/parametrizacoes/parametrizacoes.component";
import {RelatorioRecadastramentoComponent} from "./pages/relatorio-recadastramento/relatorio-recadastramento.component";
import {RelatorioSinteticoRecadastramentoComponent} from "./components/relatorio-sintetico-recadastramento/relatorio-sintetico-recadastramento.component";
import {RelatorioAnaliticoRecadastramentoComponent} from "./components/relatorio-analitico-recadastramento/relatorio-analitico-recadastramento.component";
import { PosCampanhaRecadastramentoComponent } from './pages/pos-campanha-recadastramento/pos-campanha-recadastramento.component';
import {DadosExcecoesService} from "./service/dados-excecoes/dados-excecoes.service";
import {CampanhasService} from "./service/campanhas/campanhas.service";
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import localePt from '@angular/common/locales/pt';

import {MatDatepickerModule} from '@angular/material/datepicker';
import { OrientacoesComponent } from './components/orientacoes/orientacoes.component';
import { PosCampanhaService } from "./service/posCampanha/pos-campanha.service";
import { PosCampanhaServiceAba3 } from "./service/posCampanhaAba3/pos-campanha-aba3.service";
import { Aba1PosrecadComponent } from "./components/pos-recadastramento/aba1-posrecad/aba1-posrecad.component";
import { Aba3PosrecadComponent } from "./components/pos-recadastramento/aba3-posrecad/aba3-posrecad.component";
import { FiltroPosRecadComponent } from "./components/pos-recadastramento/filtro/filtro-pos-recad.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { Aba2PosrecadComponent } from "./components/pos-recadastramento/aba2-posrecad/aba2-posrecad.component";
import { Aba5PosrecadComponent } from "./components/pos-recadastramento/aba5-posrecad/aba5-posrecad.component";
import { PosCampanhaServiceAba4 } from './service/posCampanhaAba4/pos-campanha-aba4.service';
import { PosCampanhaServiceAba5 } from './service/posCampanhaAba5/pos-campanha-aba5.service';
import { Aba7PosrecadComponent } from './components/pos-recadastramento/aba7-posrecad/aba7-posrecad.component';
import { Aba8PosrecadComponent } from './components/pos-recadastramento/aba8-posrecad/aba8-posrecad.component';
import { PosCampanhaServiceAba7 } from './service/posCampanhaAba7/pos-campanha-aba7.service';
import { PosCampanhaServiceAba8 } from './service/posCampanhaAba8/pos-campanha-aba8.service';
import { PosCampanhaServiceAba6 } from './service/posCampanhaAba6/pos-campanha-aba6.service';
import { Aba9PosrecadComponent } from './components/pos-recadastramento/aba9-posrecad/aba9-posrecad.component';
import { PosCampanhaServiceAba9 } from './service/posCampanhaAba9/pos-campanha-aba9.service';
import { Aba10PosrecadComponent } from './components/pos-recadastramento/aba10-posrecad/aba10-posrecad.component';
import { Aba11PosrecadComponent } from './components/pos-recadastramento/aba11-posrecad/aba11-posrecad.component';
import { Aba12PosrecadComponent } from './components/pos-recadastramento/aba12-posrecad/aba12-posrecad.component';
import {PosCampanhaServiceAba12} from "./service/posCampanhaAba12/pos-campanha-aba12.service";
import {PosCampanhaServiceAba10} from "./service/posCampanhaAba10/pos-campanha-aba10.service";
import { PosCampanhaAba11Service } from './service/posCampanhaAba11/pos-campanha-aba11.service';
import { RelatorioPlanoSaudeRecadastramentoComponent } from './components/relatorio-plano-saude-recadastramento/relatorio-plano-saude-recadastramento.component';
import { RecadastramentoAba15Component } from './components/recadastramento-aba15/recadastramento-aba15.component';
import {
  OnlyUppercaseAndNeverEspecialCharDirective
} from "./directives/only-uppercase-and-never-especial-char.directive";
import { CampanhasServidorService } from "./service/campanha-servidor/campanhas-servidor.service";
import {
  AfastamentoELicencasComponent
} from "./pages/relatorio-srh/afastamento-e-licencas/afastamento-e-licencas.component";
import { BeneficiosComponent } from "./pages/relatorio-srh/beneficios/beneficios.component";
import { CertidaoContribuicaoPlanservComponent } from "./components/relatorios-srh/certidao-contribuicao-planserv/certidao-contribuicao-planserv.component";
import { CertidaoContribuicaoSulamericaComponent } from "./components/relatorios-srh/certidao-contribuicao-sulamerica/certidao-contribuicao-sulamerica.component";

import {
  CertidaoAfastamentosFaltasAbonosComponent
} from "./components/relatorios-srh/certidao-afastamentos-faltas-abonos/certidao-afastamentos-faltas-abonos.component";
import {
  CertidaoAfastamentosLicencasComponent
} from "./components/relatorios-srh/certidao-afastamentos-licencas/certidao-afastamentos-licencas.component";
import {
  CertidaoFeriasNaoUsufruidasComponent
} from "./components/relatorios-srh/certidao-ferias-nao-usufruidas/certidao-ferias-nao-usufruidas.component";
import {
  CertidaoFeriasUsufruidasComponent
} from "./components/relatorios-srh/certidao-ferias-usufruidas/certidao-ferias-usufruidas.component";
import {
  CertidaoLicencaPremioNaoUsufruidaComponent
} from "./components/relatorios-srh/certidao-licenca-premio-nao-usufruida/certidao-licenca-premio-nao-usufruida.component";
import {
  CertidaoLicencaPremioUsufruidaComponent
} from "./components/relatorios-srh/certidao-licenca-premio-usufruida/certidao-licenca-premio-usufruida.component";
import { EscalaFeriasComponent } from "./components/relatorios-srh/escala-ferias/escala-ferias.component";
import {
  EscalaFeriasLotacaoComponent
} from "./components/relatorios-srh/escala-ferias-lotacao/escala-ferias-lotacao.component";
import { ServidorService } from "./service/servidor/servidor.service";
import { DynamicFormComponent } from "./commons/formulario-dinamico/dynamic-form/dynamic-form.component";
import {
  DynamicFormInputComponent
} from "./commons/formulario-dinamico/dynamic-form-input/dynamic-form-input.component";
import {
  AutoCompleteServidorComponent
} from "./commons/formulario-dinamico/auto-complete-servidor/auto-complete-servidor.component";
import { BetweenDateComponent } from "./commons/formulario-dinamico/between-date/between-date.component";
import { DynamicFieldDirective } from "./commons/formulario-dinamico/directives/dynamic-field.directive";
import { RelatoriosSrhService } from "./service/relatorios-srh/relatorios-srh.service";
import {
  DynamicFormInputAnoComponent
} from "./commons/formulario-dinamico/dynamic-form-input-ano/dynamic-form-input-ano.component";
import { FeriasComponent } from "./pages/relatorio-srh/ferias/ferias.component";
import { FolgasComponent } from "./pages/relatorio-srh/folgas/folgas.component";
import { FolgasCategoriasComponent } from "./components/relatorios-srh/folgas-categorias/folgas-categorias.component";
import { SolicitacaoAuxilioSaudeComponent } from './pages/solicitacao-auxilio-saude/solicitacao-auxilio-saude.component';
import { DadosPessoaisComponent } from './components/dados-pessoais/dados-pessoais.component';
import { SolicitacaoAuxSaudeService } from './service/solicitacao-aux-saude/solicitacao-aux-saude.service';
import { TipoSolicitacaoComponent } from './components/tipo-solicitacao/tipo-solicitacao.component';
import {
  InformacoesFuncionaisComponent
} from "./pages/relatorio-srh/informacoes-funcionais/informacoes-funcionais.component";
import {
  InformacoesFuncionaisCategoriasComponent
} from "./components/relatorios-srh/informacoes-funcionais-categorias/informacoes-funcionais-categorias.component";
import { DateComponent } from "./commons/formulario-dinamico/date/date.component";
import { ModalAnexoComponent } from './components/modal-anexo/modal-anexo.component';
import { ModalExcluirComponent } from './components/modal-excluir/modal-excluir.component';
import { ModalAvisoComponent } from './components/modal-aviso/modal-aviso.component';
import { CustomDateAdapter } from './utils/date_util';
import { ListaSolicitacoesComponent } from './pages/lista-solicitacoes/lista-solicitacoes.component';
import { VisualizarSolicitacaoComponent } from './pages/visualizar-solicitacao/visualizar-solicitacao.component';
import { DetalhesSolicitacaoComponent } from './pages/detalhes-solicitacao/detalhes-solicitacao.component';
import { ModalRejeitarComponent } from './components/modal-rejeitar/modal-rejeitar.component';
import { ModalJustificativaComponent } from './components/modal-justificativa/modal-justificativa.component';

const globalSettings: RecaptchaSettings = { siteKey: '6Lc8vGwUAAAAAOsheXbsSd7qKpwLv0t2ECF1i___' };

const maskConfig: Partial<IConfig> = {
  validation: false,
};

// const globalSettings: RecaptchaSettings = {siteKey: '6Lc8vGwUAAAAAOsheXbsSd7qKpwLv0t2ECF1i___'};

registerLocaleData('pt-BR');

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    BaseComponent,
    LoginComponent,
    SidenavComponent,
    BensValoresComponent,
    BarraNavegacaoComponent,
    CardInfoServidorComponent,
    RecadastramentoAtivosComponent,
    RecadastramentoAba1Component,
    RecadastramentoAba2Component,
    RecadastramentoAba3Component,
    RecadastramentoAba4Component,
    RecadastramentoAba5Component,
    RecadastramentoAba6Component,
    RecadastramentoAba7Component,
    RecadastramentoAba8Component,
    RecadastramentoAba9Component,
    RecadastramentoAba10Component,
    RecadastramentoAba11Component,
    RecadastramentoAba12Component,
    RecadastramentoAba13Component,
    RecadastramentoAba14Component,
    RecadastramentoAba15Component,
    SidenavComponent,
    OrientacoesComponent,
    CampanhasComponent,
    ExcecoesComponent,
    ParametrizacoesComponent,
    ModalDialogComponent,
    OnlyNumberDirective,
    TelefonePipe,
    HomeComponent,
    RelatorioRecadastramentoComponent,
    RelatorioAnaliticoRecadastramentoComponent,
    RelatorioSinteticoRecadastramentoComponent,
    RelatorioPlanoSaudeRecadastramentoComponent,
    PosCampanhaRecadastramentoComponent,
    Aba1PosrecadComponent,
    Aba3PosrecadComponent,
    FiltroPosRecadComponent,
    Aba2PosrecadComponent,
    Aba4PosrecadComponent,
    Aba5PosrecadComponent,
    Aba6PosrecadComponent,
    Aba7PosrecadComponent,
    Aba8PosrecadComponent,
    Aba9PosrecadComponent,
    Aba10PosrecadComponent,
    Aba11PosrecadComponent,
    Aba12PosrecadComponent,
    OnlyUppercaseAndNeverEspecialCharDirective,
    AfastamentoELicencasComponent,
    BeneficiosComponent,
    CertidaoContribuicaoPlanservComponent,
    CertidaoContribuicaoSulamericaComponent,
    CertidaoAfastamentosFaltasAbonosComponent,
    CertidaoAfastamentosLicencasComponent,
    CertidaoFeriasNaoUsufruidasComponent,
    CertidaoFeriasUsufruidasComponent,
    CertidaoLicencaPremioNaoUsufruidaComponent,
    CertidaoLicencaPremioUsufruidaComponent,
    EscalaFeriasComponent,
    EscalaFeriasLotacaoComponent,
    DynamicFormComponent,
    DynamicFormInputComponent,
    AutoCompleteServidorComponent,
    BetweenDateComponent,
    DynamicFieldDirective,
    DynamicFormInputAnoComponent,
    FeriasComponent,
    FolgasComponent,
    FolgasCategoriasComponent,
    SolicitacaoAuxilioSaudeComponent,
    DadosPessoaisComponent,
    TipoSolicitacaoComponent,
    InformacoesFuncionaisComponent,
    InformacoesFuncionaisCategoriasComponent,
    DateComponent,
    ModalAnexoComponent,
    ModalExcluirComponent,
    ModalAvisoComponent,
    ListaSolicitacoesComponent,
    VisualizarSolicitacaoComponent,
    DetalhesSolicitacaoComponent,
    ModalRejeitarComponent,
    ModalJustificativaComponent
  ],
  imports: [
    MatDialogModule,
    MatIconModule,
    BrowserModule,
    MaterialModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    NgxMaskModule,
    BlockUIModule,
    BlockUIModule.forRoot(),
    AuthModule,
    ChartsModule,
    NgxHmCarouselModule,
    RecaptchaModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      maxOpened: 1, timeOut: 2000 // Define o número e o tempo máximo de toasters abertos simultaneamente
    }),
    MatIconModule,
    NgxMaskModule.forRoot(),
    NgbModule,
    ReactiveFormsModule,
    MatExpansionModule,
    CurrencyMaskModule,
    MatSidenavModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatSlideToggleModule
  ],
  providers: [
    PadraoService,
    IdentityStorage,
    AuthGuard,
    AuthenticationService,
    UsuarioService,
    HomeService,
    DatePipe,
    UploadService,
    ImpostoRendaService,
    AutorizacaoDeAcessoService,
    HandleErrorService,
    DadosPessoaisAba1,
    EnumService,
    DocumentosPessoaisAba3Service,
    LocalidadesIbgeService,
    EnderecoAba4Service,
    EnderecoViaCep,
    DadosContatoAba8,
    DadosParentescoServiceAba9,
    ConselhoAba13Service,
    TrabalhadorEstrangeiroAba5Service,
    TrabalhadorEstrangeiroAba5Service,
    DadosPortadorDeficienciaServiceAba6,
    DadosAuxilioTransporte,
    DadosExcecoesService,
    CampanhasService,
    PosCampanhaService,
    PosCampanhaServiceAba3,
    PosCampanhaServiceAba4,
    PosCampanhaServiceAba5,
    PosCampanhaServiceAba8,
    PosCampanhaServiceAba6,
    PosCampanhaServiceAba7,
    PosCampanhaServiceAba9,
    PosCampanhaServiceAba10,
    PosCampanhaAba11Service,
    PosCampanhaServiceAba12,
    CampanhasServidorService,
    ServidorService,
    RelatoriosSrhService,
    SolicitacaoAuxSaudeService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: RECAPTCHA_SETTINGS, useValue: globalSettings },
    { provide: MatPaginatorIntl, useClass: forwardRef(() => MatPaginatorIntlPortuguese) },
    { provide: LOCALE_ID, useValue: 'pt-BR'},
    { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] },
  
    //{ provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    //  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },

  ],
  entryComponents: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
